import React from "react";
import { createSelectable } from "react-selectable-fast";
import ShiftEvent from "./ShiftEvent";

const HourColumn = ({ isSelected, isSelecting, selectableRef, shifts, name, onDeleteShift, onEditPlan }) => {

  return (
    <div
      ref={selectableRef}
      className={`hourColumn ${isSelected || isSelecting ? "selected" : ""}`}>
      {/* style={{ ...(shifts.length > 0 ? { height: `${(shifts.length * 25) + 40}px` } : {}) }}> */}
      {isSelecting ? (
        <div className="selecting-hours">
          <div style={{ whiteSpace: "nowrap" }}>
            {name.name.substr(0, 2)}-{name.name === "23:00" ? name.end_name : name.end_name.substr(0, 2)}
          </div>
        </div>
      ) : ""}
      {shifts.length > 3 ? (
        <div>
          <div style={{ height: "25px" }}>
            <ShiftEvent onEditPlan={onEditPlan} onDeleteShift={onDeleteShift} shift={shifts[0]} key={0} index={0} />
          </div>
          <div style={{ height: "25px" }}>
            <ShiftEvent onEditPlan={onEditPlan} onDeleteShift={onDeleteShift} shift={shifts[1]} key={1} index={1} />
          </div>
          <div style={{ height: "25px" }}>
            <ShiftEvent onEditPlan={onEditPlan} onDeleteShift={onDeleteShift} shift={shifts[2]} key={2} index={2} />
          </div>
          <div className="shift-group">
            +{shifts.length - 3} Shifts
          </div>
        </div>)
        : (shifts.map((shift, index) => <div style={{ height: "25px" }} key={index}><ShiftEvent onEditPlan={onEditPlan} onDeleteShift={onDeleteShift} shift={shift} key={index} index={index} /></div>))
      }
      <div style={{ height: "40px" }}></div>
    </div >
  )

}
export default createSelectable(HourColumn);
